// extracted by mini-css-extract-plugin
module.exports = {"container":"_23Z0sbDxzWm_5u2nNEl3fd","select":"_3FXsLXnTG-0112QHXCKN6t","selected":"_1oFQ2nbuD91FryEuBjCD1","tag":"_2xF4J9DjIi-hE7XrIy7sG7"};